import styles from './style.module.css'

const ScrollBody: React.FC<React.PropsWithChildren> = ({children}) => {
    return (
      <div className={styles.scrollBody}>
        {children}
      </div>
    )
  }
  
  export {
    ScrollBody
  }